import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const DashboardService = {
  // Define your API functions here
  getList: async () => {
    const response = await apiService.get("/dashboard/stats");
    return response.data;
  },
  getReport: async (year) => {
    const response = await apiService.get(
      `/dashboard/stats/monthly?year=${year}`
    );
    return response.data;
  },
  getTopItem: async (timeRange, topN) => {
    const response = await apiService.get(
      `/dashboard/top-selling-items?timeRange=${timeRange}&topN=${topN}`
    );
    return response.data;
  },
  create: async (postData) => {
    const response = await apiService.post("/sections", postData);
    return response.data;
  },

  detail: async (id) => {
    const response = await apiService.get(`/sections/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/sections/${id}`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/sections/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getDayBookSummary: async (fromDate, toDate) => {
    const response = await apiService.get(
      `/dashboard/daybook-summary?fromDate=${fromDate}&toDate=${toDate}`
    );
    return response.data;
  },
};

export default DashboardService;
